import React, { Component } from "react";
import ReactDOM from "react-dom";
import Button from "@mui/material/Button";
import Headers from "./Layouts/Headers";
import Footers from "./Layouts/Footers";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import $ from 'jquery'
class MedicalHome extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      paymentsstatus: "pending",
    };
  }

  componentDidMount() {
    //remove loader
    // document.getElementById("LoadingModal").style.display = "none";
    $('.access_search_in_module').click(function(e){
      e.preventDefault()
      var id = $(this).attr('id');
      localStorage.setItem('currentModule', id)
      window.location.href = "/search/in/module"
    });
  }
  render() {
    return (
      <div>
        <Headers></Headers>
        <div className="container  more-top-padding homecontainer">
          <div className="row">
            <div className="center full-width">
              <Paper
                variant=""
                sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}
              >
                <h1 className="color-blue">
                  Hargeisa Obstetrics and Gynecology Department{" "}
                </h1>
              </Paper>
            </div>
            <div className="full-width">
              <div className="row center">
                <div className="">
                  <a className="navbar-brand access_search_in_module" id="triage" href="/search/in/module">
                    <Card className="dashboardcards center" variant="outlined">
                      <CardActionArea>
                        <div className="full-width center pt-4">
                          <CardMedia
                            className="fa dashboard icons fa-question-circle color-blue"
                            component="icon"
                            alt="Triage"
                          />
                        </div>
                        <CardContent>
                          <Typography
                            gutterBottom
                            variant="h5"
                            className="center"
                            component="div"
                          >
                            Triage
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </a>
                </div>
                <div className="">
                  <a
                    className="navbar-brand access_search_in_module" id="gynecology"
                   
                  >
                    <Card
                      className="dashboardcards center"
                      sx="{{maxWidth: 200}}"
                      variant="outlined"
                    >
                      <CardActionArea classes="dashboardcardsinner">
                        <div className="full-width center pt-4">
                          <CardMedia
                            className="fa dashboard icons fa-bed color-blue"
                            component="icon"
                            alt="Triage"
                          />
                        </div>
                        <CardContent>
                          <Typography
                            gutterBottom
                            variant="h5"
                            component="div"
                            className="center"
                          >
                            Gynecology I Ward
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </a>
                </div>
                <div className="">
                  <a
                    className="navbar-brand access_search_in_module" id="gynecology2"
                    
                  >
                    <Card
                      className="dashboardcards center"
                      sx="{{maxWidth: 200}}"
                      variant="outlined"
                    >
                      <CardActionArea classes="dashboardcardsinner">
                        <div className="full-width center pt-4">
                          <CardMedia
                            className="fa dashboard icons fa-bed color-blue"
                            component="icon"
                            alt="Triage"
                          />
                        </div>
                        <CardContent>
                          <Typography
                            gutterBottom
                            variant="h5"
                            component="div"
                            className="center"
                          >
                            Gynecology II Ward
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </a>
                </div>
                <div className="">
                  <a className="navbar-brand access_search_in_module" id="labour">
                    <Card
                      className="dashboardcards center"
                      sx="{{maxWidth: 200}}"
                      variant="outlined"
                    >
                      <CardActionArea classes="dashboardcardsinner">
                        <div className="full-width center pt-4">
                          <CardMedia
                            className="fa dashboard icons fa-stethoscope color-blue"
                            component="icon"
                            alt="Triage"
                          />
                        </div>
                        <CardContent>
                          <Typography
                            gutterBottom
                            variant="h5"
                            component="div"
                            className="center"
                          >
                            Labour Room
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </a>
                </div>
                <div className="">
                  <a className="navbar-brand access_search_in_module" id="delivery">
                    <Card
                      className="dashboardcards center"
                      sx="{{maxWidth: 200}}"
                      variant="outlined"
                    >
                      <CardActionArea classes="dashboardcardsinner">
                        <div className="full-width center pt-4">
                          <CardMedia
                            className="fa dashboard icons fa-stethoscope color-blue"
                            component="icon"
                            alt="Triage"
                          />
                        </div>
                        <CardContent>
                          <Typography
                            gutterBottom
                            variant="h5"
                            component="div"
                            className="center"
                          >
                            Delivery Room
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </a>
                </div>
                <div className="">
                  <a
                    className="navbar-brand access_search_in_module" id="newborn"
                  >
                    <Card
                      className="dashboardcards center"
                      sx="{{maxWidth: 200}}"
                      variant="outlined"
                    >
                      <CardActionArea classes="dashboardcardsinner">
                        <div className="full-width center pt-4">
                          <CardMedia
                            className="fa dashboard icons fa-child color-blue"
                            component="icon"
                            alt="Triage"
                          />
                        </div>
                        <CardContent>
                          <Typography
                            gutterBottom
                            variant="h5"
                            component="div"
                            className="center"
                          >
                            New Born Unit
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </a>
                </div>
                
                <div className="">
                  <a className="navbar-brand access_search_in_module" id="theatre">
                    <Card
                      className="dashboardcards center"
                      sx="{{maxWidth: 200}}"
                      variant="outlined"
                    >
                      <CardActionArea classes="dashboardcardsinner">
                        <div className="full-width center pt-4">
                          <CardMedia
                            className="fa dashboard icons fa-scissors color-blue"
                            component="icon"
                            alt="Triage"
                          />
                        </div>
                        <CardContent>
                          <Typography
                            gutterBottom
                            variant="h5"
                            component="div"
                            className="center"
                          >
                            Operating Theatre
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </a>
                </div>
               
                <div className="">
                  <a
                    className="navbar-brand access_search_in_module" id="Post-natal">
                  
                    <Card
                      className="dashboardcards center"
                      sx="{{maxWidth: 200}}"
                      variant="outlined"
                    >
                      <CardActionArea classes="dashboardcardsinner">
                        <div className="full-width center pt-4">
                          <CardMedia
                            className="fa dashboard icons fa-bed color-blue"
                            component="icon"
                            alt="Triage"
                          />
                        </div>
                        <CardContent>
                          <Typography
                            gutterBottom
                            variant="h5"
                            component="div"
                            className="center"
                          >
                            Post-Natal Ward
                          </Typography>
                        </CardContent>
                      </CardActionArea>
                    </Card>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footers></Footers>
      </div>
    );
  }
}

export default MedicalHome;
